import { errorDescriptionFromResponse } from '../../utils/error';
import { splitRtmpUrl, resolutionForBroadcast } from '../events/broadcast-with-rtmp-controller';
import postRobot from '../../utils/post-robot.min';

const PROVIDER_ID = '62B54187-6E38-43C8-9EC4-28709EEEC382';
const V3_INITIALIZE_TIMEOUT_MS = 10000;

class EventsController {
  constructor(
    $scope,
    $state,
    $analytics,
    $q,
    $http,
    $timeout,
    $uibModal,
    EditOrCreateEventService,
    Broadcast,
    toaster,
    BandwidthTestClient,
    Requester
  ) {
    'ngInject';

    this.$scope = $scope;
    this.$state = $state;
    this.$analytics = $analytics;
    this.EditOrCreateEventService = EditOrCreateEventService;
    this.Broadcast = Broadcast;
    this.toaster = toaster;
    this.BandwidthTestClient = BandwidthTestClient;
    this.Requester = Requester;
    this.$q = $q;
    this.$http = $http;
    this.$timeout = $timeout;
    this.$uibModal = $uibModal;

    this.postRobot = postRobot;

    this.switcherAppMode = 'web';
    if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.switcher) {
      // Decide if v2 (BoxCast Switcher) or v3 (Switcher Studio). Assume v2 unless the postMessage
      // calls return, in which case we're in the v3 shell.
      this.switcherAppMode = 'boxcast_switcher_webview';

      this.initializingSwitcherStudioV3 = true;

      this.postMessage('api', { method: 'GET', path: `/api/StreamingProviders/${PROVIDER_ID}` })
        .then((event) => {
          console.log('Switcher provider settings', event);
          $timeout(() => {
            this.initializingSwitcherStudioV3 = false;
            this.switcherAppMode = 'studio_v3';
            this.provider = event.data;
          });
        })
        .catch((err) => {
          console.error(err);
          $timeout(() => (this.initializingSwitcherStudioV3 = false));
        });

      this.postMessage('api', {
        method: 'GET',
        path: `/api/StreamingProviders/${PROVIDER_ID}/SwitcherStreamSettings`,
      })
        .then((event) => {
          console.log('Current Switcher channel settings', event);
          $timeout(() => (this.currentSwitcherChannelSettings = event.data));
          this.postMessage('ui', { method: 'hideCover' });
        })
        .catch((err) => {
          console.error(err);
          $timeout(() => (this.currentSwitcherChannelSettings = {}));
          this.postMessage('ui', { method: 'hideCover' });
        });

      $timeout(() => {
        if (this.initializingSwitcherStudioV3) {
          this.initializingSwitcherStudioV3 = false;
        }
      }, V3_INITIALIZE_TIMEOUT_MS);
    }

    this.tab = 'scheduled';
    this.loadFutureBroadcasts();
    this.newEventQuickSettings = {
      showModeToggle: false,
      showBoxCasters: false,
      showClone: false,
      showRecurring: false,
      showFBLive: false, // XXX: FB.ui api cannot be used inside Switcher webview
      showPreview: false,
    };

    this.$analytics.eventTrack(`new-event-switcher`, { category: 'open', label: '' });

    this.service = EditOrCreateEventService.getInstance();
    this.service.initBroadcast();
    this.service.initScope($scope);
    this.service.visibility = 'private'; //default to private for Switcher events

    this.maxValidStep = 1;
    this.step = 1;
    this.showError = false;

    // XXX: don't need BoxCasters here since inside switcher
    this.service.boxcasters.$promise.then(() => {
      this.service.broadcast.boxcaster_id = 'stream_source:switcher';
    });

    this.testBandwidth().then((bw) => {
      $scope.$evalAsync(() => {
        this.bandwidth = bw;

        // initialize the broadcast
        let { videoBitrate, audioBitrate } = this.BandwidthTestClient.getBitrates(
          bw.availableBandwidth
        );
        if (this.service.broadcast.target_video_bitrate == 'default') {
          this.service.broadcast.target_video_bitrate = videoBitrate;
        }
        if (this.service.broadcast.target_audio_bitrate == 'default') {
          this.service.broadcast.target_audio_bitrate = audioBitrate;
        }
      });
    });

    this.loading = true;
    this.loadingPromises = [
      this.service.boxcasters.$promise,
      this.service.channels.$promise,
      this.futureBroadcasts.$promise,
    ];
    $q.all(this.loadingPromises).then(() => (this.loading = false));

    // Auto-focus on page load
    setTimeout(() => $('#eventName').focus(), 0);
  }

  postMessage(route, params) {
    params = params || {};
    var method = params.method;
    var path = params.path;

    return postRobot
      .send(window.parent, route, params)
      .then((event) => {
        return event;
      })
      .catch((err) => {
        throw err;
      });
  }

  testBandwidth() {
    return this.BandwidthTestClient.runTestOrUseRecentCached();
  }

  loadFutureBroadcasts() {
    this.futureBroadcasts = this.Broadcast.query({
      'filter.stream_source': 'switcher',
      q: 'timeframe:current timeframe:preroll timeframe:future',
      s: 'starts_at',
      l: '20',
    });
  }

  isActive(broadcast) {
    // TODO: reconcile difference between "active" (meaning switcher knows about it)
    // and "current" (meaning it's scheduled to be running now)
    return (
      broadcast.timeframe == 'current' &&
      this.currentSwitcherChannelSettings &&
      this.currentSwitcherChannelSettings['channel-name'] == broadcast.name
    );
  }

  isSelected(broadcast) {
    return this.selectedBroadcast == broadcast;
  }

  toggleSelectedBroadcast(broadcast) {
    if (this.selectedBroadcast === broadcast) {
      this.selectedBroadcast = null;
    } else {
      this.selectedBroadcast = broadcast;
    }
  }

  activateBroadcast(broadcast) {
    const { $q, toaster } = this;

    var promise;
    if (broadcast.timeframe == 'current') {
      promise = $q((res, rej) => {
        this.Broadcast.get(
          { id: broadcast.id },
          (b) => res(b),
          (err) => rej(err)
        );
      });
    } else {
      promise = this.EditOrCreateEventService.activateBroadcast(broadcast);
    }

    promise
      .then((broadcast) => {
        this.waitForOrigin(broadcast).then((broadcast) => {
          if (this.switcherAppMode == 'boxcast_switcher_webview') {
            window.webkit.messageHandlers.switcher.postMessage({ action: 'dismiss' });
          } else {
            this.pokeV3APIWithNewBroadcast(
              broadcast,
              () => {
                this.postMessage('ui', {
                  method: 'terminateBCProfileCreation',
                  params: { profile: this.currentSwitcherChannelSettings },
                });
              },
              () => {
                this.toaster.pop('warning', 'Unable to communicate with Switcher Studio.');
              }
            );
          }
        });
      })
      .catch((response) => {
        let errorDetails = errorDescriptionFromResponse(response);
        this.toaster.pop('warning', 'Unable to activate the broadcast.\n\n' + errorDetails);
      });

    this.selectedBroadcast = null;
    this.loadingPromises = [promise];
  }

  pokeV3APIWithNewBroadcast(broadcast, successCB = null, errorCB = null) {
    const { $timeout, toaster } = this;

    var rtmpParts = splitRtmpUrl(broadcast.rtmp_ingestion_url);
    var resolution = resolutionForBroadcast(broadcast);
    var data = angular.extend({}, this.currentSwitcherChannelSettings, {
      StreamingProviderId: PROVIDER_ID,
      url: rtmpParts[0],
      'rtmp-stream': rtmpParts[1],
      //'version': '1',
      'audio-channel-count': 2,
      'audio-sample-rate': 44100,
      'video-frame-height': resolution.height,
      'video-frame-width': resolution.width,
      //'user-editable': true,
      'channel-name': broadcast.name,
    });
    if (broadcast.target_audio_bitrate && !isNaN(broadcast.target_audio_bitrate)) {
      data['audio-bit-rate'] = broadcast.target_audio_bitrate;
    }
    if (broadcast.target_video_bitrate && !isNaN(broadcast.target_video_bitrate)) {
      data['video-bit-rate'] = broadcast.target_video_bitrate;
    }
    var method = 'PUT';
    if (Object.keys(this.currentSwitcherChannelSettings).length == 0) {
      method = 'POST';
    }
    return this.postMessage('api', {
      method: method,
      path: `/api/StreamingProviders/${PROVIDER_ID}/SwitcherStreamSettings`,
      data: data,
    })
      .then((event) => {
        console.log('Updated Switcher channel settings', event);
        if (event.data && event.data.ExceptionMessage) {
          $timeout(() =>
            toaster.pop(
              'warning',
              `There was an error communicating with Switcher Studio: ${event.data.ExceptionMessage}`
            )
          );
        } else {
          $timeout(() => (this.currentSwitcherChannelSettings = event.data));
        }
        if (successCB) {
          $timeout(() => successCB());
        }
      })
      .catch((err) => {
        console.error(err);
        $timeout(() => (this.initializingSwitcherStudioV3 = false));
        if (errorCB) {
          $timeout(() => errorCB());
        }
      });
  }

  stopBroadcast(broadcast) {
    var promise = this.EditOrCreateEventService.stopBroadcast(broadcast)
      .then(() => {
        this.loadFutureBroadcasts();
      })
      .catch((response) => {
        let errorDetails = errorDescriptionFromResponse(response);
        this.toaster.pop(
          'warning',
          'Unable to stop broadcast. Please check your fields and try again.\n\n' + errorDetails
        );
      });
    this.selectedBroadcast = null;
    this.loadingPromises = [promise];
  }

  submit() {
    // XXX: called by new-event-quick directive when scheduling
    const { toaster } = this;

    this.showError = false;
    this.submitting = true;

    this.service
      .saveChanges()
      .then((broadcast) => {
        this.submitting = false;

        this.$analytics.eventTrack(`new-event-${this.wizard ? 'wizard' : 'quick'}`, {
          category: 'saved',
          label: '',
        });

        // NOTE: now that the event is "active" (due to time-based scheduling), we can dismiss
        // the web view and let the app take over.
        this.toaster.pop('success', 'Event successfully scheduled.');

        if (this.switcherAppMode == 'boxcast_switcher_webview') {
          window.webkit.messageHandlers.switcher.postMessage({ action: 'dismiss' });
        } else {
          if (broadcast.timeframe == 'current') {
            this.waitForOrigin(broadcast).then((broadcast) => {
              console.log('Origin ready for broadcast', broadcast);
              this.pokeV3APIWithNewBroadcast(
                broadcast,
                () => {
                  this.postMessage('ui', {
                    method: 'terminateBCProfileCreation',
                    params: { profile: this.currentSwitcherChannelSettings },
                  });
                },
                () => {
                  this.toaster.pop('warning', 'Unable to communicate with Switcher Studio.');
                }
              );
            });
          } else {
            this.loadFutureBroadcasts();
            this.tab = 'scheduled';
          }
        }
      })
      .catch((error) => {
        let errorDetails = errorDescriptionFromResponse(error);
        if (errorDetails == 'invalid') {
          this.showError = true;
          $('html, body').animate({ scrollTop: 0 });
        } else {
          console.error(error);
          this.toaster.pop(
            'warning',
            'Unable to save broadcast. Please check your fields and try again.\n\n' + errorDetails
          );
        }
        this.submitting = false;
        this.$analytics.eventTrack(`new-event-${this.wizard ? 'wizard' : 'quick'}`, {
          category: 'error',
          label: errorDetails,
        });
      });
  }

  waitForOrigin(broadcast) {
    const { $uibModal } = this;

    var updatedBroadcast;
    return $uibModal
      .open({
        template: require('./modal-wait-for-event.html'),
        controller: function ($http, $interval, $uibModalInstance, $scope) {
          'ngInject';
          this.statusPct = 0;
          this.interval = $interval(() => {
            $http
              .get(
                `${API_ROOT}/account/broadcasts/${broadcast.id}/view?channel_id=${broadcast.channel_id}`
              )
              .then((view) => {
                this.statusPct = view.data.progress;
                if (this.statusPct >= 90 || view.data.status != 'catching_up') {
                  this.cancel();
                }
              });
          }, 1000);
          $scope.$on('$destroy', () => {
            $interval.cancel(this.interval);
          });
          this.cancel = () => {
            $uibModalInstance.close();
          };
        },
        controllerAs: 'vm',
      })
      .result.then(() => {
        updatedBroadcast = this.Broadcast.get({ id: broadcast.id });
        return updatedBroadcast.$promise;
      })
      .then(() => {
        return updatedBroadcast;
      });
  }
}

export default EventsController;



// WEBPACK FOOTER //
// ./app/pages/switcher-studio/events.js